<script>
import * as d3 from 'd3'
import { camelCase, keyBy, mapKeys, mapValues } from 'lodash'
import chart from '@/mixins/chart'

export default {
  mixins: [chart],
  name: 'ChartPoliticiansByCountry',
  filters: {
    formatNumber: d3.format(',')
  },
  props: {
    valueField: {
      type: String,
      default: 'total'
    }
  },
  computed: {
    tsv () {
      return this.$options.tsv.map(row => {
        return mapKeys(row, (_, k) => camelCase(k))
      })
    },
    tsvHashByIso3 () {
      return keyBy(this.tsv, 'iso3')
    },
    valuesByIso3 () {
      return mapValues(this.tsvHashByIso3, this.valueField)
    }
  }
}
</script>

<template>
  <div class="chart-politicians-countries px-4 pt-4 pb-0 world-map">
    <h4>{{ chartRoute.title }}</h4>
    <choropleth-map
      :data="valuesByIso3"
      :min="0"
      :social-mode="socialMode"
      clickable
      class="chart-politicians-countries__map">
      <template #legend-cursor="{ identifier, value }">
        <div class="bg-secondary p-2 text-light text-center" v-if="identifier in tsvHashByIso3">
          <h6 class="m-0">
            {{ tsvHashByIso3[identifier].country.split(', ').reverse().join(' ') }}
          </h6>
          <template v-if="value === 1">
            1 politician
          </template>
          <template v-else>
            {{ value | formatNumber }}&nbsp;politicians
          </template>
        </div>
      </template>
    </choropleth-map>
    <p class="text-muted mt-2 small text-right">Source: Pandora Papers data</p>
  </div>
</template>

<style lang="scss" scoped>
@import '../variables.scss';

.chart-politicians-countries {
  overflow: hidden;
  min-height: 500px;
  height: 100%;
  width: 100%;
  background: url('../assets/images/bg-paper.jpg') $light no-repeat center center;
  background-size: cover;
  display: flex;
  flex-direction: column;

  .chart--social-mode & {
    background-image: url('../assets/images/bg-dark-paper.jpg');
    background-color: $secondary;
  }

  .chart--active-route-view & {
    height: calc(100vh - var(--app-footer-height, 0));
  }

  & /deep/ &__map {
    flex-grow: 1;
  }

  & /deep/ &__map .scale-legend {
    top: 100%;
    bottom: auto;
  }
}
</style>

<tsv>
country	total	iso3
China; Macau	1	MAC
Andorra	2	AND
Angola	9	AGO
Hong Kong Special Administrative Region	4	HKG
Argentina	4	ARG
Bahrain	4	BHR
Bolivia	3	BOL
Serbia	4	SRB
Brazil	9	BRA
Chile	2	CHL
Colombia	11	COL
Gabon	3	GAB
Ukraine	38	UKR
Lebanon	6	LBN
Pakistan	7	PAK
Ghana	3	GHA
Panama	5	PAN
United Arab Emirates	11	ARE
Malaysia	2	MYS
Russian Federation	19	RUS
Congo-Brazzaville	2	COG
Costa Rica	1	CRI
Côte d’Ivoire	5	CIV
India	6	IND
Czech Republic	4	CZE
Dominican Republic	7	DOM
Ecuador	8	ECU
Haiti	3	HTI
El Salvador	4	SLV
Indonesia	2	IDN
Mexico	7	MEX
Mongolia	2	MNG
Saudi Arabia	5	SAU
Georgia	1	GEO
Guatemala	4	GTM
Honduras	11	HND
China	2	CHN
Jordan	4	JOR
Kuwait	1	KWT
Iraq	1	IRQ
Italy	4	ITA
Nigeria	10	NGA
Kazakhstan	8	KAZ
Peru	3	PER
Qatar	3	QAT
Romania	2	ROU
Sri Lanka	2	LKA
Kenya	2	KEN
Luxembourg	1	LUX
Malta	1	MLT
Armenia	1	ARM
Azerbaijan	2	AZE
Belgium	2	BEL
Monaco	1	MCO
Montenegro	1	MNE
Mozambique	1	MOZ
Bulgaria	2	BGR
Cameroon	1	CMR
Chad	2	TCD
China; Hong Kong Special Administrative Region	2	HKG
Comoros	1	COM
Djibouti	1	DJI
France	3	FRA
Portugal	3	PRT
Germany	1	DEU
Hungary	1	HUN
Israel	2	ISR
Jersey	1	JEY
Spain	5	ESP
Kosovo	2	XKX
Albania	1	ALB
Kyrgyzstan	1	KGZ
Tajikistan	1	TJK
Uganda	1	UGA
Mauritania	1	MRT
Moldova	1	MDA
Morocco	3	MAR
Nepal	1	NPL
Netherlands	1	NLD
Norway	1	NOR
Paraguay	1	PRY
Philippines	3	PHL
Slovenia	2	SVN
South Africa	2	ZAF
Lithuania	1	LTU
Switzerland	1	CHE
Tunisia	1	TUN
Turkmenistan	2	TKM
United Kingdom of Great Britain and Northern Ireland	9	GBR
Uruguay	1	URY
Venezuela	8	VEN
Zimbabwe	2	ZWE
</tsv>
